<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('MEDICAL_DATA') }}</h3>
        </div>
        <steps v-if="!single" :activeStep="2" :steps="5" class="text-xs-center mb-4"></steps>
        <div class="content__wrapper">
            <div class="d-flex align-center mb-5">
                <h4 class="stepper__content__title with-description">{{ $t('DO_YOU_MENSTRUATE_REGULARLY') }}</h4>
                <div class="description box-shadow box-shadow--arrow-left">
                    {{ $t('ASK_FOR_CYCLE_DETAILS') }}
                </div>
            </div>
            <div class="flex-center flex-row">
                <label class="fake-label">
                    <input class="custom-input" type="radio" value="YES" name="radio" v-model="s4q2Val" />
                    <span class="input-container">{{ $t('YES') }}</span>
                    <span class="checkmark"></span>
                </label>
                <label class="fake-label">
                    <input class="custom-input" type="radio" value="NO" name="radio" v-model="s4q2Val" />
                    <span class="input-container">{{ $t('NO') }}</span>
                    <span class="checkmark"></span>
                </label>
                <label class="fake-label">
                    <input class="custom-input" type="radio" value="DO_NOT_MENSTRUATE" name="radio" v-model="s4q2Val" />
                    <span class="input-container">{{ $t('DO_NOT_MENSTRUATE') }}</span>
                    <span class="checkmark"></span>
                </label>
            </div>
            <div class="flex-center">
                <div>
                    <div v-if="s4q2Val === 'YES'" class="row d-flex col-xs-12 my-3">
                        <h4 class="flex-header">{{ $t('GIVE_AVERAGE_CYCLE_LENGTH') }}</h4>
                        <el-select v-model="s4q2_1Val" :placeholder="$t('SELECT')" class="flex-select">
                            <el-option v-for="item in select_period" :key="item" :label="item" :value="item" />
                        </el-select>
                    </div>
                    <div class="row" v-if="s4q2Val === 'YES' || s4q2Val === 'NO'">
                        <div class="col-xs-12">
                            <h4 class="mt-3">{{ $t('GIVE_LAST_PERIOD_COLON') }}</h4>
                        </div>
                        <div class="col-xs-12 col-sm-8 col-sm-offset-2">
                            <vue-calendar :first-day="1" :events="events" @dayClicked="dayClicked"></vue-calendar>
                        </div>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <div v-if="single">
                    <button @click="cancel" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('CANCEL') }}
                    </button>
                    <button
                        v-if="validateQ"
                        @click="save"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>
                    <button v-if="!validateQ" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('SAVE') }}
                    </button>
                </div>
                <div v-else>
                    <button @click.stop="goTo(1)" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('PREVIOUS') }}
                    </button>
                    <button
                        v-if="validateQ"
                        @click.stop="goTo(3)"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('NEXT') }}
                    </button>
                    <button v-if="!validateQ" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5">
                        {{ $t('NEXT') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';
import { mapActions, mapState } from 'vuex';
import { mapUserSurveyData } from '../../../main';

export default {
    name: 'survey-step4-q2',
    props: {
        single: Boolean,
    },
    data() {
        return {
            s4q2Val: this.$store.getters.survey.section4.q2,
            s4q2_1Val: this.$store.getters.survey.section4.q2_1,
            lastPeriod: this.$store.getters.survey.section4.lastPeriod,
            select_period: ['25', '26', '27', '28', '29', '30', '31', '32', '33'],
        };
    },
    computed: {
        ...mapState(['user']),
        events() {
            return this.lastPeriod !== ''
                ? [
                      {
                          title: 'Ostatnia miesiączka',
                          start: this.lastPeriod,
                          end: this.lastPeriod,
                          class: 'last-period-day',
                      },
                  ]
                : [];
        },
        validateQ() {
            if (this.s4q2Val === 'YES' && this.s4q2_1Val !== '' && this.lastPeriod !== '') {
                return true;
            } else if (this.s4q2Val === 'NO' && this.lastPeriod !== '') {
                return true;
            } else {
                return this.s4q2Val === 'DO_NOT_MENSTRUATE';
            }
        },
    },
    methods: {
        ...mapActions(['updateUserSurvey']),
        goTo(id) {
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    active_section: id,
                    q2: this.s4q2Val,
                    q2_1: this.s4q2Val === 'YES' ? this.s4q2_1Val : '',
                    lastPeriod: this.lastPeriod,
                },
            });
        },
        cancel() {
            this.$emit('cancel');
        },
        save() {
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    q2: this.s4q2Val,
                    q2_1: this.s4q2Val === 'YES' ? this.s4q2_1Val : '',
                    lastPeriod: this.lastPeriod,
                },
            });
            this.updateUserSurvey({ ...this.user.patient.survey, ...mapUserSurveyData() }).then(this.cancel);
        },
        dayClicked(event) {
            const today = this.$moment();
            const selectedDay = this.$moment(event.date);
            if (today.diff(selectedDay, 'seconds') >= 0) {
                this.lastPeriod = selectedDay.format('YYYY-MM-DD');
            }
        },
    },
    components: {
        Steps,
    },
};
</script>



// WEBPACK FOOTER //
// survey-step4-q2.vue?68c285fc